// extracted by mini-css-extract-plugin
export var cardBg = "slice-module--cardBg--f1db8";
export var cardColContent = "slice-module--cardColContent--d9497";
export var cardColImage = "slice-module--cardColImage--46da3";
export var links = "slice-module--links--d8e12";
export var preTitle = "slice-module--preTitle--1bddb";